var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "marTL marBL padTL padBL padLL padRL",
      staticStyle: {
        "max-width": "710px",
        "margin-left": "auto",
        "margin-right": "auto",
        border: "3px solid #d5d5d5"
      }
    },
    [
      _c("div", { staticClass: "clearfix" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "disIb pcOnly",
            staticStyle: {
              float: "right",
              "background-color": "#fcfcfc",
              padding: "0.1em 0.7em",
              color: "#666",
              "text-align": "right",
              border: "1px solid #bebdbd"
            }
          },
          [
            _c(
              "a",
              {
                staticStyle: { "text-decoration": "none" },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("printScr")
                  }
                }
              },
              [_vm._v("인쇄")]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix fntP" }, [
          _c("div", { staticStyle: { border: "1px solid #d5d5d5" } }, [
            _c(
              "p",
              { staticClass: "clearfix", staticStyle: { padding: "0.8em" } },
              [
                _c(
                  "span",
                  {
                    staticClass: "floL bolder moTxtC",
                    staticStyle: { width: "30%", "font-size": "1.2em" }
                  },
                  [_vm._v("출발")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "floR moTxtC",
                    staticStyle: {
                      width: "70%",
                      "text-align": "right",
                      "vertical-align": "text-bottom"
                    }
                  },
                  [
                    _vm._v(
                      "예약번호 : " +
                        _vm._s(
                          _vm.scheduleList[0].mas_departure_reserved_number
                        )
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "fntH5 txtC bolder",
                staticStyle: {
                  "background-color": "#f5f5f5",
                  padding: "0.5em 0em",
                  "border-top": "1px solid #d5d5d5",
                  "border-bottom": "1px solid #d5d5d5"
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.scheduleList[0].mas_departure_flight) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flightTimeInfo",
                staticStyle: {
                  width: "100%",
                  "min-height": "auto",
                  border: "0px",
                  overflow: "hidden"
                }
              },
              [
                _c("div", { staticClass: "leftDiv" }, [
                  _c("strong", { staticStyle: { color: "#1874cd" } }, [
                    _vm._v(_vm._s(_vm.scheduleList[0].mas_departure_start))
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticStyle: { margin: "0.2em 0em" } }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.scheduleList[0].mas_departure_start_date)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticStyle: { color: "#1874cd" } }, [
                    _vm._v(_vm._s(_vm.scheduleList[0].mas_departure_start_time))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "rightDiv" }, [
                  _c("strong", { staticStyle: { color: "#1874cd" } }, [
                    _vm._v(_vm._s(_vm.scheduleList[0].mas_departure_end))
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticStyle: { margin: "0.2em 0em" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.scheduleList[0].mas_departure_end_date))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticStyle: { color: "#1874cd" } }, [
                    _vm._v(_vm._s(_vm.scheduleList[0].mas_departure_end_time))
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "padTS padBM",
                staticStyle: {
                  width: "90%",
                  margin: "0px auto",
                  "font-size": "0.9em",
                  "border-top": "1px solid #d5d5d5"
                }
              },
              [
                _c("b", [
                  _vm._v(
                    "비고 : " +
                      _vm._s(_vm.scheduleList[0].mas_departure_remarks)
                  )
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "marTL marBM padTL",
          staticStyle: { "border-top": "1px solid #d5d5d5" }
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix fntP" }, [
            _c("div", { staticStyle: { border: "1px solid #d5d5d5" } }, [
              _c(
                "p",
                { staticClass: "clearfix", staticStyle: { padding: "0.8em" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "floL bolder moTxtC",
                      staticStyle: { width: "30%", "font-size": "1.2em" }
                    },
                    [_vm._v("도착")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "floR moTxtC",
                      staticStyle: {
                        width: "70%",
                        "text-align": "right",
                        "vertical-align": "text-bottom"
                      }
                    },
                    [
                      _vm._v(
                        "예약번호 : " +
                          _vm._s(_vm.scheduleList[0].mas_return_reserved_number)
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "fntH5 txtC bolder",
                  staticStyle: {
                    "background-color": "#f5f5f5",
                    padding: "0.5em 0em",
                    "border-top": "1px solid #d5d5d5",
                    "border-bottom": "1px solid #d5d5d5"
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.scheduleList[0].mas_return_flight)
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flightTimeInfo",
                  staticStyle: {
                    width: "100%",
                    "min-height": "auto",
                    border: "0px",
                    overflow: "hidden"
                  }
                },
                [
                  _c("div", { staticClass: "leftDiv" }, [
                    _c("strong", { staticStyle: { color: "#1874cd" } }, [
                      _vm._v(_vm._s(_vm.scheduleList[0].mas_return_start))
                    ]),
                    _vm._v(" "),
                    _c("strong", { staticStyle: { margin: "0.2em 0em" } }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.scheduleList[0].mas_return_start_date)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("strong", { staticStyle: { color: "#1874cd" } }, [
                      _vm._v(_vm._s(_vm.scheduleList[0].mas_return_start_time))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rightDiv" }, [
                    _c("strong", { staticStyle: { color: "#1874cd" } }, [
                      _vm._v(_vm._s(_vm.scheduleList[0].mas_return_end))
                    ]),
                    _vm._v(" "),
                    _c("strong", { staticStyle: { margin: "0.2em 0em" } }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.scheduleList[0].mas_return_end_date))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("strong", { staticStyle: { color: "#1874cd" } }, [
                      _vm._v(_vm._s(_vm.scheduleList[0].mas_return_end_time))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "padTS padBM",
                  staticStyle: {
                    width: "90%",
                    margin: "0px auto",
                    "font-size": "0.9em",
                    "border-top": "1px solid #d5d5d5"
                  }
                },
                [
                  _c("b", [
                    _vm._v(
                      "비고 : " + _vm._s(_vm.scheduleList[0].mas_return_remarks)
                    )
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h2",
      {
        staticClass: "floL fntP fntL bolder",
        staticStyle: { padding: "0px", color: "#1874cd" }
      },
      [
        _c(
          "span",
          {
            staticClass: "disIb marRS",
            staticStyle: { "vertical-align": "middle" }
          },
          [
            _c("img", {
              attrs: { src: require("../img/joinIcon_a.png"), alt: "" }
            })
          ]
        ),
        _vm._v("항공일정\n    ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "marTM marBM padTM",
        staticStyle: { "border-top": "1px solid #d5d5d5" }
      },
      [
        _c(
          "p",
          {
            staticClass: "marTS fntH6 fntL txtC bolder",
            staticStyle: {
              "background-color": "#ebf5ff",
              padding: "0.8em",
              color: "#1874cd"
            }
          },
          [
            _c("img", {
              staticStyle: {
                "padding-right": "0.3em",
                "vertical-align": "text-bottom"
              },
              attrs: { src: require("../img/joinIcon_ab.png"), alt: "" }
            }),
            _vm._v("출국일정\n      ")
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marBM" }, [
      _c(
        "p",
        {
          staticClass: "fntH6 fntL txtC bolder",
          staticStyle: {
            "background-color": "#ebf5ff",
            padding: "0.8em",
            color: "#1874cd"
          }
        },
        [
          _c("img", {
            staticStyle: {
              "padding-right": "0.3em",
              "vertical-align": "text-bottom"
            },
            attrs: { src: require("../img/joinIcon_ab2.png"), alt: "" }
          }),
          _vm._v("입국일정\n      ")
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02bfed92", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02bfed92","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nca/components/masInternationalSchedule.vue
// module id = null
// module chunks = 